import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import GrievanceForm from "../components/GrievanceForm";

const Grievance = () => {
  return (
    <div>
      <Navbar />
      <main>
        <div>
          <section className="contact-address-area">
            <div className="container">
              <div className="sec-title-style1 text-center max-width">
                <div className="title" data-aos="fade-down">
                  SUBMIT A GRIEVANCE
                </div>
                <div className="text">
                  <div className="decor-left">
                    <span></span>
                  </div>
                  <p>We take every concern seriously</p>
                  <div className="decor-right">
                    <span></span>
                  </div>
                </div>
                <div className="bottom-text ">
                  <p>
                    If you have a complaint or concern about our services,
                    staff, or how we handle your data, please let us know
                    using the form below. You can also email us directly at{" "}
                    <a href="mailto:grievance@outcess.com.ng">grievance@outcess.com.ng</a>.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <GrievanceForm />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Grievance;
